import React from 'react';
import { Link } from 'react-router-dom';
import IconCollection from "../../IconCollection/IconCollection";
import Loader from '../../Component/Loader/Loader';
import moment from 'moment';
import PropTypes from 'prop-types';
import { updateEventType } from '../../redux/reducers/playersReducer';
import { useDispatch } from 'react-redux';
const EventCard = ({ match, handleOverlay, handleNavigateHistoryPage, reLoadData, setShowWindow, setSelectId ,isMouseOverInput}) => {
  
  const dispatch = useDispatch();
  const handleEventType = (type) => {
    dispatch(updateEventType(type))
  }
  return (
    <div className={`${!isMouseOverInput ? 'max-w-full':'max-w-[936px]'} w-full p-4 rounded-md flex flex-col md:flex-row justify-between items-center ${match.status_work_fsp == "Ongoing" ? "bg-tertiary" : match.status_work_fsp == "waiting for confirmation" ? "bg-[#E3FDF3]" : (match.status_work_fsp == "waiting for event" || match.status_work_fsp == "visiting") ? "bg-[#FCF3E7]" : match.status_work_fsp == "Ended" ? "bg-[#F2F2F2]" : match.status_work_fsp == "Declined" ? "bg-[#a4262c21]" : "bg-tertiary"}`}>
      <div className={`flex flex-col md:flex-row gap-2 border-b md:border-none pb-2 md:pb-0 mb-1 md:mb-0 w-full md:gap-2 xl:gap-6 items-start md:items-center flex-1 ${match.status_work_fsp == "Ongoing" ? "border-[#EFE2D7]" : match.status_work_fsp == "waiting for confirmation" ? "border-[#98F8D1]" : (match.status_work_fsp == "waiting for event" || match.status_work_fsp == "visiting") ? "border-[#EFE2D7]" : match.status_work_fsp == "Ended" ? "border-[#E8E8E8]" : match.status_work_fsp == "Declined" ? "border-[#a4262c21]" : "border-[#EFE2D7]"}`}>
        <div className="max-w-full md:max-w-[120px] xl:max-w-[188px] w-full h-auto justify-between bg-[#4A4A4A] p-3 rounded-md flex flex-col gap-2 md:gap-1 xl:gap-2">

          <div className="flex items-center gap-2">
            <IconCollection name="clock" height="24px" smHeight="20px" smWidth="20px" width="24px" />
            <p className="font-bebas text-sm md:text-[10px] xl:text-xl text-light">
              {match.event_time_start ? moment(`2023-01-01T${match.event_time_start}`).format('h:mm A') : 'TBD'}{match.event_time_finish ? ` - ${moment(`2023-01-01T${match.event_time_finish}`).format('h:mm A')}` : ''}
            </p>
          </div>
          <div className="flex items-center gap-[6px]">
            <IconCollection name="location" height="24px" smHeight="20px" smWidth="20px" width="24px" />
            <p className="font-montserrat text-sm md:text-[8px] xl:text-base font-medium text-light ">
              {match.event_location}
            </p>
          </div>
        </div>
        <div className="flex-1 w-full">
          <p className="text-[#A57C52] font-montserrat font-medium text-base">
            {match.teamId}
          </p>
          <div className="flex flex-col gap-2 min-h-[60px] items-start">
            <div className="text-xl lg:text-xl md:text-xl xl:text-xl font-bebas text-[#1A1A1A] block">
              <span>GC{match.event_group_id} </span>&nbsp;  {match.event_group_name}
            </div>
            <div className='flex flex-wrap gap-1'>
              <p className="text-xl lg:text-xl md:text-xl xl:text-3xl font-bebas text-[#1A1A1A]">
                <span className='font-montserrat  text-[#A57C52]'>{match?.event_code}</span>  {match?.event_name?.split("-")[0]}{" "}
              </p>
              <p className="text-xl lg:text-xl md:text-xl xl:text-3xl font-bebas text-[#7D7D7D]">
                {match?.event_name?.split("-")[1]}{" "}
              </p>
            </div>
          </div>

          <div className="max-w-[134px] w-full h-4 flex justify-between items-center">
            <div 

            onClick={() => [
              handleOverlay(match.event_id, match.event_code, match.team_a_name, match.team_b_name),
              handleEventType(match.team_a_event_type_id ? match.team_a_event_type_id : match.team_b_event_type_id)
            ]} 
            className="text-[#A57C52] cursor-pointer font-montserrat font-medium text-xs hover:underline "
            
            >
              Settings
            </div>
            <div className="h-3 w-[1px] bg-[#E8D8CA]"></div>
            <div onClick={() => handleNavigateHistoryPage(match.event_id)} className="text-[#A57C52] cursor-pointer font-montserrat font-medium text-xs hover:underline">
              Logs
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-full md:max-w-[85px] lg:max-w-[120px] xl:max-w-[217px] w-full flex flex-col justify-center md:justify-end items-end">
        <p className="text-[#4A4A4A] capitalize text-sm font-montserrat font-medium pb-2 inline-block  md:text-center  w-full max-w-full md:max-w-[70px] xl:max-w-[135px] text-center">
          {match.status_work_fsp}
        </p>
        {reLoadData ? <Loader /> : (
          <>
            {match.status_work_fsp == "Ended" && " "}
            {match.status_work_fsp == "Ongoing" && (
              <div className="flex justify-end gap-2 w-full">
                <button className="max-w-full md:max-w-[70px] xl:max-w-[135px] w-full h-[40px] rounded border-none bg-primary flex justify-center items-center text-xl md:text-sm xl:text-xl font-bebas text-light">
                  Resume
                </button>
              </div>
            )}
            {(match.status_work_fsp == 'waiting for event' || match.status_work_fsp == "visiting" || match.status_work_fsp == "assigned") && (
              <div className="flex justify-end gap-2 w-full">
                <Link to={`/players/${match.event_id}`} className="max-w-full md:max-w-[80px] xl:max-w-[135px] w-full h-[40px] rounded border-none bg-primary flex justify-center items-center text-xl md:text-sm xl:text-xl font-bebas text-light">
                  Start Now
                </Link>
              </div>
            )}
            {!match.status_work_fsp && (
              <Link to={`/players/${match.event_id}`} className="max-w-full md:max-w-[80px] xl:max-w-[135px] w-full h-[40px] rounded border-none bg-primary flex justify-center items-center text-xl md:text-sm xl:text-2xl font-bebas text-light">
                Start Now
              </Link>
            )}
            {match.status_work_fsp == "waiting for confirmation" && (
              <div className="flex justify-center sm:justify-end gap-2 w-full">
                <button onClick={() => [setShowWindow("no"), setSelectId({ id: match.status_id, photographer_id: match.photographer_fsp_id, status_work: 2 })]} className="max-w-full md:max-w-[30px] lg:max-w-[40px] xl:max-w-[70px] w-full h-[40px] rounded border-none bg-light flex justify-center items-center text-xl md:text-sm xl:text-2xl font-bebas text-dark">
                  No
                </button>
                <button onClick={() => [setShowWindow("yes"), setSelectId({ id: match.status_id, photographer_id: match.photographer_fsp_id, status_work: 1 })]} className="max-w-full md:max-w-[45px] lg:max-w-[70px] xl:max-w-[135px] w-full h-[40px] rounded border-none bg-primary flex justify-center items-center text-xl md:text-sm xl:text-2xl font-bebas text-light">
                  Yes
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

EventCard.propTypes = {
  match: PropTypes.shape({
    status_work_fsp: PropTypes.string,
    event_time_start: PropTypes.string,
    event_time_finish: PropTypes.string,
    event_location: PropTypes.string,
    teamId: PropTypes.string,
    event_group_id: PropTypes.string,
    event_group_name: PropTypes.string,
    event_code: PropTypes.string,
    event_name: PropTypes.string,
    event_id: PropTypes.string,
    status_id: PropTypes.string,
    photographer_fsp_id: PropTypes.string,
    team_a_name: PropTypes.string,
    team_b_name: PropTypes.string,
  }).isRequired,
  handleOverlay: PropTypes.func.isRequired,
  handleNavigateHistoryPage: PropTypes.func.isRequired,
  reLoadData: PropTypes.bool.isRequired,
  setShowWindow: PropTypes.func.isRequired,
  setSelectId: PropTypes.func.isRequired,
  isMouseOverInput: PropTypes.bool.isRequired,
};

export default EventCard;